import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {User} from "../../models/user";
import {UserService} from "../../services/user/user.service";
import {Router} from "@angular/router";
import Swal from "sweetalert2";
import {NgModel} from '@angular/forms';

@Component({
    selector: 'app-register-agent',
    templateUrl: './register-agent.component.html',
    styleUrls: ['./register-agent.component.scss']
})
export class RegisterAgentComponent {

    @Output('step') public stepEmitter: EventEmitter<any> = new EventEmitter<any>();
    @Output('listOfSteps') public listOfStepsEmitter: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('email') email!: NgModel;
    @ViewChild('pec') pec!: NgModel;
    @ViewChild('phone') phone!: NgModel;
    @ViewChild('fiscalCode') fiscalCode!: NgModel;
    @ViewChild('vat') vat!: NgModel;
    @ViewChild('iban') iban!: NgModel;
    @ViewChild('paymentPhone') paymentPhone!: NgModel;
    @ViewChild('paymentEmail') paymentEmail!: NgModel;

    @ViewChild('nextButton6') nextButton6!: any;
    @ViewChild('nextButton7') nextButton7!: any;
    @ViewChild('nextButton8') nextButton8!: any;
    @ViewChild('nextButton9') nextButton9!: any;

    stepNumber: number = 0;
    showPassword: boolean = false;
    showConfirmPassword: boolean = false;

    stepsAgent: any[] = [
        {id: 1, title: 'Tipologia agente', text: ""},
        {id: 2, title: 'Informazioni personali', text: ""},
        {id: 3, title: 'Informazioni aziendali', text: ""},
        {id: 4, title: 'Indirizzo e contatti', text: ""},
        {id: 5, title: 'Modalità di pagamento', text: ""},
        {id: 6, title: 'Credenziali di accesso', text: ""},
        {id: 7, title: 'Termini e condizioni', text: ""},
        {id: 8, title: 'Verifica OTP', text: ""},
        {id: 9, title: 'Congratulazioni', text: ""},
    ];

    typesOfAccount: string[] = ['userAthlete', 'userParent', 'agentCommerce', 'agentFreelance', 'agentPrivate'];
    typeOfAccount?: string;

    private readonly STEP_STORAGE_KEY = 'register-agent-step';
    private readonly DATA_STORAGE_KEY = 'register-agent-data';

    private setStep(step: number) {
        this.stepNumber = step;
        localStorage.setItem(this.STEP_STORAGE_KEY, this.stepNumber.toString());
        this.saveFormData();
        this.stepEmitter.emit(this.stepNumber);
        this.updateSidebar();
    }

    newUser: User = new User();

    termsAndConditionAccepted: boolean = false;
    privacyAccepted: boolean = false;
    agentConditionClauseAccepted: boolean = false;

    confirmPassword: string = '';
    OTPCode: string = '';

    data: any[] = [];
    provinces: any[] = [];
    cities: any[] = [];

    agentDocumentFront: File | undefined;
    agentDocumentBack: File | undefined;

    responseFront: string = '';
    responseBack: string = '';

    constructor(
        public userService: UserService,
        public router: Router) {
    }

    async ngOnInit(): Promise<void> {
        this.restoreFormData();

        const savedStep = localStorage.getItem(this.STEP_STORAGE_KEY);
        if (savedStep !== null) {
            this.stepNumber = Number(savedStep);
            this.stepEmitter.emit(this.stepNumber);
        }
        if (!this.newUser.subtype) {
            this.newUser.subtype = this.typeOfAccount;
        }
        // Don't set default - let user choose
        this.updateSidebar();

        fetch('../../../assets/italia_comuni.json')
            .then((jsonData: any) => jsonData.json())
            .then((res: any) => {
                this.data = res.regioni;
                this.data.forEach((region: any) => {
                    region.province.forEach((province: any) => this.provinces.push({
                        id: province.code,
                        name: province.nome
                    }))
                })
                this.provinces.sort((a: any, b: any) => a.name > b.name ? 1 : -1)

                // Ripristina le città dopo il caricamento dei dati
                if (this.newUser.province) {
                    this.updateCities();
                }
            })
            .catch((error: any) => console.error('error fetching locationData: ', error))

    }

    updateSidebar() {
        console.log("Updating sidebar, current step: ", this.stepNumber);
        console.log("is -1", this.stepNumber === -1);
        if (Number(this.stepNumber) === -1 || Number(this.stepNumber) === 0) {
            this.listOfStepsEmitter.emit([]);
        } else {
            this.listOfStepsEmitter.emit(this.stepsAgent);
        }
    }

    async nextStep() {
        if (this.stepNumber === -1) {
            this.setStep(0);
            return;
        }

        if (this.stepNumber === 0) {
            this.setStep(1);
            return;
        }

        // Step 1: Agent type selection - no validation needed, just continue
        if (this.stepNumber === 1) {
            this.setStep(this.stepNumber + 1);
            return;
        }

        // Step 2: Personal info + Documenti - validate and continue
        if (this.stepNumber === 2) {
            if (this.isPersonalInfoValid() && this.areDocumentsValid()) {
                this.stepNumber++;
                // Skip step 3 (business info) if agent type is 4 (no VAT)
                if (this.newUser.subtype === this.typesOfAccount[4]) {
                    this.stepNumber++; // Skip to step 4
                }

                // upload documents
                this.responseFront = await this.uploadDocument(this.agentDocumentFront!);
                this.responseBack = await this.uploadDocument(this.agentDocumentBack!);

                if (this.responseFront && this.responseBack) {
                    this.newUser['documentUrlFront'] = this.responseFront;
                    this.newUser['documentUrlBack'] = this.responseBack;
                    this.setStep(this.stepNumber);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: "Errore durante il caricamento dei documenti di identità, riprovare"
                    });
                    this.stepNumber--; // fallback
                }
            }
            return;
        }

        // Step 3: Business info - validate and continue
        if (this.stepNumber === 3) {
            if (this.isBusinessInfoValid()) {
                this.setStep(this.stepNumber + 1);
            }
            return;
        }

        // Step 4: Address & Contact - validate and continue
        if (this.stepNumber === 4) {
            if (this.isAddressContactValid()) {
                this.setStep(this.stepNumber + 1);
            }
            return;
        }

        // Step 5: Payment Method - validate and continue
        if (this.stepNumber === 5) {
            if (this.isPaymentMethodValid()) {
                this.setStep(this.stepNumber + 1);
            }
            return;
        }

        // Step 6: Password - validate and continue
        if (this.stepNumber === 6) {
            if (this.isPasswordValid()) {
                if (this.nextButton7?.nativeElement) {
                    this.nextButton7.nativeElement.disabled = true;
                }
                this.setStep(this.stepNumber + 1);
            }
            return;
        }

        // Step 7: Terms - validate and send registration
        if (this.stepNumber === 7) {
            if (this.termsAndConditionAccepted && this.privacyAccepted && this.agentConditionClauseAccepted) {
                if (this.nextButton8?.nativeElement) {
                    this.nextButton8.nativeElement.disabled = true;
                }
                if (await this.sendRegistrationUser()) {
                    this.setStep(this.stepNumber + 1);
                    return;
                } else {
                    if (this.nextButton8?.nativeElement) {
                        this.nextButton8.nativeElement.disabled = false;
                    }
                    return;
                }
            }
            return;
        }

        // Step 9: OTP - handled by checkOTP method
        // Step 10: Success - no action needed
    }

    previousStep() {
        let newStep = this.stepNumber;
        if (this.stepNumber === 0) {
            newStep = -1;
        } else {
            newStep = this.stepNumber - 1;
        }

        if (newStep === 3 && this.newUser.subtype === this.typesOfAccount[4]) {
            newStep--;
        }

        this.setStep(newStep);
    }


    backToLogin() {
        this.router.navigate(['/login'])
    }

    async sendRegistrationUser() {
        let response = await this.userService.registerAgent(this.newUser)

        if (response.success) {
            return true;
        } else {
            if (response.code === "USER_ALREADY_EXIST") {
                Swal.fire({
                    icon: 'error',
                    title: "Errore, email già registrata con un altro utente!"
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: "Errore durante la creazione dell'utente, riprovare"
                })
            }
            return false;
        }
    }

    updateCities() {
        this.cities = [];
        let province: any[] = [];

        this.data.forEach((region: any) => {
            if (region.province.find((province: any) => province.code === this.newUser.province)) {
                province = region.province.find((province: any) => province.code === this.newUser.province).comuni
            }
        });

        this.cities = province.map((city: any) => city.nome);

        this.cities.sort();

    }

    selectAgentType(type: string) {
        this.newUser.subtype = type;
    }

    isPersonalInfoValid(): boolean {
        return (
            this.newUser.firstName?.trim() !== '' &&
            this.newUser.lastName?.trim() !== '' &&
            this.newUser.documentNumber?.trim() !== '' &&
            this.newUser.fiscalCode?.trim() !== '' &&
            this.fiscalCode?.valid === true
        );
    }

    isBusinessInfoValid(): boolean {
        // Business info is only required if not type 4
        if (this.newUser.subtype === this.typesOfAccount[4]) {
            return true; // Skip validation for type 4
        }
        return (
            this.newUser.businessName?.trim() !== '' &&
            this.newUser.vat?.trim() !== '' &&
            this.vat?.valid === true &&
            this.newUser.sdi?.trim() !== '' &&
            (this.newUser.pec === '' || (this.pec && this.pec.valid === true))
        );
    }

    isAddressContactValid(): boolean {
        return (
            this.newUser.address?.trim() !== '' &&
            this.newUser.addressNumber !== null &&
            this.newUser.addressNumber !== undefined &&
            this.newUser.zip?.trim() !== '' &&
            this.newUser.province?.trim() !== '' &&
            this.newUser.city?.trim() !== '' &&
            this.newUser.phone?.trim() !== '' &&
            this.phone?.valid === true &&
            this.newUser.email?.trim() !== '' &&
            this.email?.valid === true
        );
    }

    isPaymentMethodValid(): boolean {
        return (
            this.newUser.bank?.trim() !== '' &&
            this.newUser.iban?.trim() !== '' &&
            (this.iban?.valid === true || !this.iban) &&
            this.newUser.paymentPhone?.trim() !== '' &&
            (this.paymentPhone?.valid === true || !this.paymentPhone) &&
            this.newUser.paymentEmail?.trim() !== '' &&
            (this.paymentEmail?.valid === true || !this.paymentEmail)
        );
    }

    normalizeIban() {
        if (this.newUser && typeof this.newUser.iban === 'string') {
            this.newUser.iban = this.newUser.iban.replace(/\s+/g, '').toUpperCase();
        }
    }

    areDocumentsValid(): boolean {
        return !!(this.agentDocumentFront && this.agentDocumentBack);
    }

    isPasswordValid(): boolean {
        if (!this.newUser.password || !this.confirmPassword) return false;
        return this.isPasswordComplexEnough() && this.newUser.password === this.confirmPassword;
    }

    isPasswordComplexEnough(): boolean {
        if (!this.newUser.password) return false;
        const hasUpper = /[A-Z]/.test(this.newUser.password);
        const hasLower = /[a-z]/.test(this.newUser.password);
        const hasNumber = /[0-9]/.test(this.newUser.password);
        const hasSpecial = /[\W_]/.test(this.newUser.password);
        const hasMinLength = this.newUser.password.length >= 8;
        return hasUpper && hasLower && hasNumber && hasSpecial && hasMinLength;
    }

    async checkOTP(otp: string, email: string) {
        let response = await this.userService.checkOTP(otp, email);

        if (response.success) {
            localStorage.removeItem(this.STEP_STORAGE_KEY);
            localStorage.removeItem(this.DATA_STORAGE_KEY);
            this.stepNumber++;
            this.stepEmitter.emit(this.stepNumber);
            this.updateSidebar();
        } else {
            Swal.fire({icon: 'error', title: 'Non è stato possibile verificare il codice OTP inserito'})
        }
    }

    chooseDocumentFront(event: any) {
        this.agentDocumentFront = event.target.files[0];
    }

    chooseDocumentBack(event: any) {
        this.agentDocumentBack = event.target.files[0];
    }

    onDocumentDrop(event: DragEvent, side: 'front' | 'back') {
        event.preventDefault();
        const file = event.dataTransfer?.files?.[0];
        if (!file) {
            return;
        }

        if (side === 'front') {
            this.agentDocumentFront = file;
        } else {
            this.agentDocumentBack = file;
        }
    }

    async uploadDocument(file: File) {
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file)

        const {success, data} = await this.userService.uploadUser(formData);

        if (success) return data;

        return null;

    }

    private saveFormData(): void {
        const data: any = {
            newUser: { ...this.newUser },
            typeOfAccount: this.typeOfAccount,
            termsAndConditionAccepted: this.termsAndConditionAccepted,
            privacyAccepted: this.privacyAccepted,
            agentConditionClauseAccepted: this.agentConditionClauseAccepted,
            responseFront: this.responseFront,
            responseBack: this.responseBack,
        };
        // Non salvare la password per sicurezza
        delete data.newUser.password;
        // Non salvare oggetti File (non serializzabili)
        localStorage.setItem(this.DATA_STORAGE_KEY, JSON.stringify(data));
    }

    private restoreFormData(): void {
        const raw = localStorage.getItem(this.DATA_STORAGE_KEY);
        if (!raw) return;
        try {
            const data = JSON.parse(raw);
            if (data.newUser) {
                Object.assign(this.newUser, data.newUser);
            }
            if (data.typeOfAccount) {
                this.typeOfAccount = data.typeOfAccount;
                this.newUser.subtype = data.typeOfAccount;
            }
            if (data.termsAndConditionAccepted !== undefined) {
                this.termsAndConditionAccepted = data.termsAndConditionAccepted;
            }
            if (data.privacyAccepted !== undefined) {
                this.privacyAccepted = data.privacyAccepted;
            }
            if (data.agentConditionClauseAccepted !== undefined) {
                this.agentConditionClauseAccepted = data.agentConditionClauseAccepted;
            }
            if (data.responseFront) {
                this.responseFront = data.responseFront;
            }
            if (data.responseBack) {
                this.responseBack = data.responseBack;
            }
        } catch (e) {
            console.error('Error restoring agent registration form data:', e);
        }
    }
}
